<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Grid.scss";


  .container-card{
    width: 150px;
  }

  .grid-view-item:hover{
    cursor: pointer;
    background-color: #eeee;
  }

  .inactive{
    background-color: #eeee;
  }

  .vx-card__body{
    padding: 7px!important;
  }

  .custom-list{
    min-width: 215px;
  }
</style>
<template>
  <div>
    <vx-card class="m-2">
    <div class="vx-row">
      <div class="vx-col w-full my-2">
        <vs-button  @click="showConfig = !showConfig"  type="flat" color="grey" class="float-right">
          <span v-show="!showConfig"  class="font-bold">{{$t('Labels.ShowConfigAlerts')}}</span>
          <span v-show="showConfig"  class="font-bold">{{$t('Labels.HideConfigAlerts')}}</span>
        </vs-button>
        <vs-button  @click="showFilters = !showFilters"  type="flat" color="grey" class="float-right">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle mr-2"><iconFilter/></iconBase>
          <span v-show="!showFilters"  class="font-bold">{{$t('Labels.ShowFilters')}}</span>
          <span v-show="showFilters"  class="font-bold">{{$t('Labels.HideFilters')}}</span>
        </vs-button>
        <vs-button  @click="showControls = !showControls"  type="flat" color="grey" class="float-right">
          <span v-show="!showControls"  class="font-bold">{{$t('Labels.ShowControls')}}</span>
          <span v-show="showControls"  class="font-bold">{{$t('Labels.HideControls')}}</span>
        </vs-button>
      </div>
    </div>
    <div class="vx-row" v-show="showConfig">
      <div class="text-danger text-center w-full">{{$t('Messages.AlertsAll')}}</div>
      <div class="container-alerts w-full">
        <minMaxItem 
          :title="$t('Labels.Current')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid"
          paramMin="electric_current_min" 
          paramMax="electric_current_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="10"
          ></minMaxItem>
        
        <minMaxItem 
          :title="$t('Labels.Voltage')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid"
          :paramMin="`electric_voltage_min`" 
          :paramMax="`electric_voltage_max`" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1000"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ActivePower')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid"
          paramMin="active_power_min" 
          paramMax="active_power_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1000"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ReactivePower')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid"
          paramMin="reactive_power_min" 
          paramMax="reactive_power_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1000"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ApparentPower')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid" 
          paramMin="apparent_power_min" 
          paramMax="apparent_power_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1000"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.PowerFactor')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid" 
          paramMin="factor_power_min" 
          paramMax="factor_power_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1"
          :step="0.1"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ActiveEnergy')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid"
          paramMin="active_energy_min" 
          paramMax="active_energy_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="4294967295"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ReactiveEnergy')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid"
          paramMin="reactive_energy_min" 
          paramMax="reactive_energy_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="4294967295"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.Frequency')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/all`" 
          :uuid="uuid"
          paramMin="frequency_min" 
          paramMax="frequency_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="100"
          ></minMaxItem>
      </div>
    </div>
    <div  class="vx-row " v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <vs-checkbox v-model="filterLastSeen" class="font-bold mb-1">{{$t('Labels.LastSeen')}}</vs-checkbox>
      </div>
    </div>
    <div class="vx-row pt-2 pb-5" v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-1/4 sm:my-0">
        <label class="font-bold">{{$t('Labels.From')}}</label>
        <datepicker :value="filters.beginDate" format="dd-MM-yyyy" :disabled="!filterLastSeen" @selected="updateStartDate"></datepicker>  
        <div v-if="!datesValid" class="text-xs text-danger">{{$t('Messages.DatesRange')}}</div>
      </div>
      <div class="vx-col w-full my-2 sm:w-1/4 sm:my-0">
        <label class="font-bold">{{$t('Labels.To')}}</label>
        <datepicker :value="filters.endDate" format="dd-MM-yyyy" :disabled="!filterLastSeen" @selected="updateEndDate"></datepicker>
      </div>
      <div class="vx-col w-full text-center hidden sm:inline-block sm:w-auto">
        <vs-button @click="getResponse()" :disabled="!datesValid" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
        <vs-button @click="resetFilters()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </div>
    <div class="vx-row mb-3" v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-1/4 sm:my-0">
        <label class="font-bold">{{$t('Labels.Serie')}}</label>
        <vs-input class="w-full" v-model="filters.serie" />
      </div>
      <div class="vx-col w-full my-2 sm:w-1/4 sm:my-0 sm:pt-3">
        <ul>
          <li>
            <vs-radio v-model="filters.status" vs-name="radios1" vs-value="1" color="success">{{$t('Labels.On')}}</vs-radio>
          </li>
          <li>
          <vs-radio v-model="filters.status" vs-name="radios1" vs-value="0" color="danger">{{$t('Labels.Off')}}</vs-radio>
          </li>
        </ul>
      </div>
      <div class="vx-col w-full my-2 sm:w-1/4 sm:my-0 sm:pt-3">
        <vs-dropdown class="bg-white py-3 w-full border-2 border-solid border-grey rounded-lg " vs-custom-content vs-trigger-click>
          <a class="a-icon" href.prevent>
            {{$t("Labels.Circuit")}}
            <vs-icon class="" icon="expand_more"></vs-icon>
          </a>
          <vs-dropdown-menu class="custom-list">
            <vs-checkbox class="my-1" v-model="circuitsAll">{{$t('Labels.All')}}</vs-checkbox>
            <vs-checkbox class="my-1" v-model="circuitsSelected" :vs-value="item.uuid" :key="item.objectID" v-for="item in circuits">{{item.name}}</vs-checkbox>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </div>
    <div class="vx-row mb-3" v-show="showFilters">
      <div class="vx-col w-full sm:w-1/4">
        <label  class="font-bold">{{$t('Labels.Current')}}</label>
        <vs-slider v-model="filters.current" text-fixed="%"  :min="0" :max="100"/>
      </div>
      <div class="vx-col  w-full sm:w-1/4">
        <label  class="font-bold">{{$t('Labels.Voltage')}}</label>
        <vs-slider v-model="filters.voltage" text-fixed="%"  :min="0" :max="100"/>
      </div>
      <div class="vx-col  w-full sm:w-1/4">
        <label  class="font-bold">{{$t('Labels.ActivePower')}}</label>
        <vs-slider v-model="filters.power" text-fixed="%"  :min="0" :max="100"/>
      </div>
      <div class="vx-col  w-full sm:w-1/4">
        <label  class="font-bold">{{$t('Labels.ActiveEnergy')}}</label>
        <vs-slider v-model="filters.energy" text-fixed="%"  :min="0" :max="100"/>
      </div>
    </div>
    <div class="vx-row px-2 py-5" v-show="showFilters">
      <div class="vx-col w-full text-center sm:hidden">
        <vs-button @click="getResponse()" :disabled="!datesValid" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
        <vs-button @click="resetFilters()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </div>
    <div class="vx-row" v-show="showControls">
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0 text-center">
        <iconLight width="80" height="80" iconColor="#ffbd59" :level="slideLight" />
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0 pt-8 text-center">
        <div class="inline-block align-middle font-bold" :class="{'text-grey': controlLight }" >Off</div>
        <div class="inline-block align-middle mx-2">
          <vs-switch v-model="controlLight" color="success"/>
        </div>
        <div class="inline-block align-middle font-bold" :class="{'text-grey': !controlLight }">On</div>
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0  pt-6 text-center">
        <vs-slider v-model="slideLight" :min="0" :max="100" text-fixed="%"/>
      </div>
      <div class="vx-col  w-full my-2 sm:w-auto sm:my-0 text-center">
        <vs-button @click="requestPassword()" color="primary" class="mr-2 mt-6">{{$t('Labels.Apply')}}</vs-button>
      </div>
    </div>
    </vx-card>
    <vx-card class="m-2">
    <div class="vx-row my-5">
      <div class="vx-col">
        <label class="font-bold align-middle mr-2">{{$t('Labels.OrderBy')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="columnOrders" v-model="byColumn" :reduce="v => v.value"/>
        <vs-button size="small" @click="filterOrders('ASC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder == 'ASC'}">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterAsc/></iconBase>
        </vs-button>
        <vs-button  size="small" @click="filterOrders('DESC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder !== 'ASC'}">
          <iconBase iconName="filter_desc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterDesc/></iconBase>
        </vs-button>   
      </div>
    </div>
    <div class="text-center py-6" v-if="response.length == 0">{{$t('Labels.NoData')}}</div>
    <div class="grid-container">
      <div class="vx-row match-height mt-4">
        <div :key="item.objectID" @click="goToDetail(item.uuid)" class="vx-col lg:w-1/4 sm:w-1/2 w-full" v-for="item in response">
            <vx-card class="grid-view-item mb-base overflow-hidden py-2" :class="{'inactive': !item.updatedAt }">
                <div class="text-center my-2">
                  <iconLight class="align-middle" width="50" height="50" iconColor="#ffbd59" :level="parseInt(item.dimming) * 100 / 255" />
                  <span class="font-bold align-middle">{{Math.ceil(parseInt(item.dimming) * 100 / 255)}} %</span>
                </div>
                <div class="font-bold text-lg text-center">{{item.name}}</div>
                <div class="text-xs text-center mb-2">{{$t('Labels.Name')}}</div>
                <div class="font-bold text-lg text-center" v-if="item.luminaires_circuit">
                  <div class="w-5 h-5 inline-block rounded-sm align-middle" :style="{ 'background-color': item.luminaires_circuit.color }"></div>
                  <div class="inline-block ml-2 align-middle">{{item.luminaires_circuit.name}}</div>
                </div>
                <div v-else class="font-bold text-lg text-center">N/A</div>
                <div class="text-xs text-center mb-2">{{$t('Labels.Circuit')}}</div>
              <vx-tooltip :text="item.updatedAt || $t('Labels.Inactive')" class="text-center">
                  <div class=" text-center text-xs mb-2">{{item.updatedAt.length > 0 ? relativeTimeConvert(item.updatedAt) : $t('Labels.Inactive')}}</div>
                </vx-tooltip>
            </vx-card>
        </div>
      </div>
       <vs-pagination v-if="response" :max="5" :total="totalPages" v-model="currentx"></vs-pagination>
    </div>
    </vx-card>
  </div>
</template>
<script>
import {request} from '@/request.js'
import statusItem from '@/components/statusItem/statusItem.vue'
import Datepicker from 'vuejs-datepicker'
import {formatDate, empty, getExactNumer} from '@/helpers.js'
import vSelect from 'vue-select'
import iconBase from '@/components/icons/iconBase'
import iconFilterAsc from '@/components/icons/iconFilterAsc'
import iconFilterDesc from '@/components/icons/iconFilterDesc'
import iconEnergy from '@/components/icons/iconEnergy'
import iconFilter from '@/components/icons/iconFilter'
import iconLight from '@/components/icons/iconLight'
import {globalPassActions} from '@/globalPass'
import minMaxItem from '@/components/minMaxItem/minMaxItem.vue'

export default {
  components: {
    statusItem,
    Datepicker,
    'v-select': vSelect,
    iconFilterDesc,
    iconFilterAsc,
    iconBase,
    iconEnergy,
    iconFilter,
    iconLight,
    minMaxItem
  },
  data () {
    return {
      response: [],
      currentx: 1,
      totalPages: 0,
      selected:[],
      filters:{
        limit: 20,
        offset: 0,
        byColumn: 'updatedAt',
        byOrder: 'ASC',
        serie:null,
        beginDate: new Date(),
        endDate: new Date(),
        status: this.$route.query.status !== undefined ? this.$route.query.status : null,
        current: [null, null],
        voltage: [null, null],
        power: [null, null],
        energy: [null, null]
      },
      filterLastCharge: false,
      filterLastSeen: false,
      columnOrders:[
        {label: this.$t('Labels.Serie'), value: 'serie'},
        {label: this.$t('Labels.Circuit'), value: 'circuit'},
        {label: this.$t('Labels.LastSeen'), value: 'updatedAt'}
      ],
      byColumn: 'updatedAt',
      byPage:[
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 75, value: 75},
        {label: 100, value: 100}
      ],
      showFilters: false,
      showConfig: false,
      controlLight: false,
      slideLight: 0,
      showControls: false,
      circuits:[],
      circuitsAll: true,
      circuitsSelected: [],
      uuid: null
    }
  },

  methods: {
    async getResponse () {
      this.$vs.loading()
      const filter = {}
      filter.limit = this.filters.limit
      filter.offset = this.filters.offset
      filter.byColumn = this.filters.byColumn
      filter.byOrder = this.filters.byOrder
      filter.serie = this.filters.serie
      filter.name = this.filters.name
      filter.state = this.filters.status
      if (this.filters.current[1] !== null && this.filters.current[0] === null) this.filters.current[0] = 0  
      filter.begin_electric = getExactNumer(this.filters.current[0], 10)
      filter.end_electric = getExactNumer(this.filters.current[1], 10)
      if (this.filters.voltage[1] !== null && this.filters.voltage[0] === null) this.filters.voltage[0] = 0
      filter.begin_voltage = getExactNumer(this.filters.voltage[0], 1000)
      filter.end_voltage = getExactNumer(this.filters.voltage[1], 1000)
      if (this.filters.power[1] !== null && this.filters.power[0] === null) this.filters.power[0] = 0 
      filter.begin_power = getExactNumer(this.filters.power[0], 1000)
      filter.end_power = getExactNumer(this.filters.power[1], 1000)
      if (this.filters.energy[1] !== null && this.filters.energy[0] === null) this.filters.energy[0] = 0
      filter.begin_energy = getExactNumer(this.filters.energy[0], 4, 294, 967, 295)
      filter.end_energy = getExactNumer(this.filters.energy[1], 4, 294, 967, 295)

      if (!this.circuitsAll) filter.luminary_circuit_uuid = this.circuitsSelected

      if (this.filterLastSeen) {
        filter.begin_date = formatDate(this.filters.beginDate)
        filter.end_date = formatDate(this.filters.endDate)
      }

      const params = {
        url: 'luminaires_devices',
        method: 'GET',
        params: filter
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        this.setPages(response.data.data.count)
      }).catch(() => {
        this.response = []
        this.totalPages = 0
      }).finally(() => {
        this.$vs.loading.close()
      })
      
    },
    resetFilters () {
      this.filters.serie = null
      this.filters.circuit = null
      this.filters.last_seen = new Date()
    },
    filterOrders (param) {
      this.filters.byOrder = param
      this.getResponse()
    },
    relativeTimeConvert (date) {
      return this.$dayjs().to(this.$dayjs(date))
    },
    goToDetail (uuid) {
      if (!empty(uuid)) window.location.href = `/luminarias/${uuid}`
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    },
    requestPassword () {
      globalPassActions.show()
    },
    async update () {
      this.selected = []
      this.response.forEach(element => {
        this.selected.push(element.uuid)
      })

      const params = {
        url: 'luminaires_devices/update_masive',
        method: 'PUT',
        params: {
          uuids: this.selected.join(','),
          dimming: Math.ceil((this.slideLight * 255) / 100)
        }
      }
      await request(params).then(() => {
        this.getResponse()
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    updateStartDate (date) {
      this.filters.beginDate = date
    },
    updateEndDate (date) {
      this.filters.endDate = date
    },
    async getCircuits () {
      const params = {
        url: 'luminaires_circuits/list',
        method: 'GET'
      }
      await request(params).then(response => {
        this.circuits = response.data.data
        this.circuitsAll = true
        this.circuits.forEach(element => {
          this.circuitsSelected.push(element.uuid)
        })
      }).finally(() => {
        this.$vs.loading.close()
      })
    }
  },

  created () {
    screen.width < '576' ? this.showFilters = false : this.showFilters = true
    this.getResponse()
    this.getCircuits()
  },
  computed: {
    isVisiblePassword () {
      return globalPassActions.getStatus()
    },
    datesValid () {
      const begin = new Date(this.filters.beginDate)
      const end = new Date(this.filters.endDate)
      return ((begin <= end && this.filterLastSeen) || this.filterLastSeen === false)  
    } 
  },
  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getResponse()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    },
    controlLight (newVal) {
      if (!newVal) this.slideLight = 0
      else if (this.slideLight === 0) this.slideLight = 100 
    },
    slideLight (newVal) {
      if (newVal > 0 && this.controlLight === false) this.controlLight = true
      else if (newVal === 0 && this.controlLight === true) this.controlLight = false
    },
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible === false) this.update()
    },
    circuitsAll (val, old) {
      if (val === true && old === false) {
        this.circuitsSelected = []
        this.circuits.forEach(element => {
          this.circuitsSelected.push(element.uuid)
        })
      }
    },
    circuitsSelected (val) {
      if (val.length < this.circuits.length) this.circuitsAll = false
    },
    showControls (val) {
      if (val) {
        this.showFilters = false
        this.showConfig = false
      }
    },
    showFilters (val) {
      if (val) {
        this.showControls = false
        this.showConfig = false
      }
    },
    showConfig (val) {
      if (val) {
        this.showControls = false
        this.showFilters = false
      }
    }
  }
}
</script>